import styled from 'styled-components';

import { hoverCapable } from '../../../styles/hover';

export const ContainerMap = styled.div`
  /* Referencia de los botones del mapa (recentrar y pantalla completa). */
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const styleMap = {
  animation: 'fadeInAnimation ease 3s',
  animationIterationCount: '1',
  animationFillMode: 'forwards',
  flexGrow: '1',
  height: '100%',
  width: '100%',
  borderRadius: '0.8rem',
};

/**
 * Pila de botones del mapa, abajo a la izquierda: recentrar abajo y pantalla
 * completa encima. Misma esquina, tamaño y aspecto que los del mapa del
 * recorrido (MapWithSegments), para que un mapa de ROIS se maneje igual en
 * todas partes. Abajo a la derecha quedan los + y - de Google (solo a pantalla
 * completa) y arriba a la izquierda Mapa y Satélite.
 */
export const MapControls = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.spacing.m};
  bottom: ${({ theme }) => theme.spacing.m};
  z-index: 10;
  display: flex;
  flex-direction: column-reverse;
  gap: 0.8rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    left: ${({ theme }) => theme.spacing.s};
    bottom: ${({ theme }) => theme.spacing.s};
  }
`;

export const MapControlButton = styled.button`
  width: 3.6rem;
  height: 3.6rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  transition: box-shadow 0.15s ease;

  /* Guard táctil: sin él el resaltado se queda pegado tras el toque en
     tablet y en el APK (ver .claude/rules/hover-tactil.md). */
  ${hoverCapable} {
    &:hover {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
    }
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 3.2rem;
    height: 3.2rem;

    svg {
      width: 1.6rem;
      height: 1.6rem;
    }
  }
`;

/**
 * El mapa a pantalla completa, pintado en el body (portal) y no en su sitio:
 * dentro de un modal con animación (el visor de fotos) un position fixed se
 * mide contra el modal, no contra la pantalla, y solo llenaría el modal. Va
 * por encima de los modales de ROIS (BaseModal está en 100000).
 */
export const FullscreenLayer = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  z-index: 100001;
  display: flex;
  background: ${({ theme }) => theme.colors.white};
`;
